/**
 * @file
 * TEMPORARY plumbing for access Pusher connectivity status in counter error checks.
 */

/*
 * Types.
 */

interface PusherStatus {
  readonly connectionState: string;
  readonly privateChannel: {
    readonly isSubscribed: boolean;
    readonly isPending: boolean;
    readonly isCancelled: boolean;
  };
}

/*
 * State.
 */

let pusherStatusProvider: (() => PusherStatus) | undefined;

/*
 * API.
 */

export function setPusherStatusProvider(provider: (() => PusherStatus) | undefined) {
  pusherStatusProvider = provider;
}

export function getPusherStatus(): PusherStatus | undefined {
  return pusherStatusProvider?.();
}
